import { render, staticRenderFns } from "./RegisterEmisor.vue?vue&type=template&id=21a6866d"
import script from "./RegisterEmisor.vue?vue&type=script&lang=js"
export * from "./RegisterEmisor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports